<template>
  <div class="qingwu">
    <div class="shop_top"><shop-top :subnav_show="subnav_show" change_color></shop-top></div>
    <div><banner :list="banner_list"></banner></div>
    <!-- <banner-bottom-adv :index_adv="banner_bottom_adv"></banner-bottom-adv> -->
    <div class="shop_content">
      <!--秒杀-->
      <!-- <seckill :list="seckill_goods_list" :info="seckill_info"></seckill> -->

      <div v-for="(v, k) in goods_list" :key="k">
        <!-- <shop-index-adv :adv="goods_list_bottom_adv[k]"></shop-index-adv> -->
        <shop-product-block
          :class_info="v"
          :goods_list="v.items"
          :adv="goods_list_left_adv[k]"
        ></shop-product-block>
      </div>
      <!-- <shop-index-adv></shop-index-adv>
      <shop-product-block></shop-product-block> -->
    </div>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { getAdList, getShowcase } from "@/api/api";

import ShopTop from "@/components/home/public/head.vue";
import banner from "@/components/home/public/banner.vue";
import BannerBottomAdv from "@/components/home/public/banner_bottom_adv.vue";
import seckill from "@/components/home/public/seckill.vue";
import ShopIndexAdv from "@/components/home/public/shop_index_adv.vue";
import ShopProductBlock from "@/components/home/public/shop_product_block.vue";
import ShopFoot from "@/components/home/public/shop_foot.vue";
export default {
  components: {
    ShopTop,
    banner,
    BannerBottomAdv,
    seckill,
    ShopIndexAdv,
    ShopProductBlock,
    ShopFoot,
  },
  props: {},
  data() {
    return {
      banner_list: [], // 幻灯片
      banner_bottom_adv: [
        {
          id: 6,
          ap_id: 5,
          adv_title: "x",
          adv_link: "\/",
          adv_image:
            "http:\/\/api.qingwuit.com\/Uploads\/adv\/2019_11_13\/15736349798484.jpg",
          adv_start: 1573574400,
          adv_end: 1902758400,
          adv_sort: 0,
          adv_type: 0,
        },
        {
          id: 7,
          ap_id: 5,
          adv_title: "2",
          adv_link: "\/",
          adv_image:
            "http:\/\/api.qingwuit.com\/Uploads\/adv\/2019_11_13\/15736350111164.jpg",
          adv_start: 1573574400,
          adv_end: 1923321600,
          adv_sort: 0,
          adv_type: 0,
        },
        {
          id: 8,
          ap_id: 5,
          adv_title: "3",
          adv_link: "\/",
          adv_image:
            "http:\/\/api.qingwuit.com\/Uploads\/adv\/2019_11_13\/15736350582872.jpg",
          adv_start: 1573574400,
          adv_end: 1923926400,
          adv_sort: 0,
          adv_type: 0,
        },
      ], // 三联广告图片
      subnav_show: true,
      goods_list: [],
      goods_list_left_adv: [], //PC_首页商品列表左侧图片
      goods_list_bottom_adv: [], //PC_首页商品列表底部
      seckill_goods_list: [],
      seckill_info: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 获取首页信息
    get_index_info: function() {
      //   this.$get(this.$api.homeGetIndexInfo).then((res) => {
      //     this.banner_list = res.data.banner.adv;
      //     this.banner_bottom_adv = res.data.banner_bottom_adv.adv;
      //     this.goods_list = res.data.goods_list;
      //     this.goods_list_left_adv = res.data.goods_list_left_adv.adv;
      //     this.goods_list_bottom_adv = res.data.goods_list_bottom_adv.adv;
      //     this.seckill_goods_list = res.data.seckill_goods;
      //     this.seckill_info = res.data.seckill_info;
      //   });
    },
    //获取首页轮播
    getBrands() {
      let json = getAdList().then((res) => {
        if (res.code == 0) {
          this.banner_list = res.data;
        } else {
          reject(res.data.msg);
        }
      });
    },

    getGoodsList() {
      let json = getShowcase().then((res) => {
        if (res.code == 0) {
          this.goods_list = res.data;
        } else {
          reject(res.data.msg);
        }
      });
    },
  },
  created() {
    this.get_index_info();
    this.getBrands();
    this.getGoodsList();
  },
  mounted() {
    // 监听滚动条
    window.addEventListener(
      "scroll",
      () => {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (scrollTop > 20) {
          this.subnav_show = false;
        } else {
          this.subnav_show = true;
        }
      },
      true
    );
  },
};
</script>
<style lang="scss" scoped>
.shop_content {
  background: #f5f5f5;
  padding: 20px 0 60px 0;
  margin-top: 40px;
}
</style>
